import { Controller } from 'react-hook-form'
import PatientFormField from '../PatientFormField'
import { useFormContextPatient } from '../_utils'

const Address = () => {
    const { control } = useFormContextPatient()

    return (
        <>
            <Controller
                control={control}
                name="address.street"
                rules={{
                    required: true,
                }}
                render={({ field, fieldState: { error } }) => (
                    <PatientFormField
                        variant="input"
                        label="Numéro et voie"
                        required
                        size="0.33"
                        status={{
                            error,
                            valid: (field.value?.trim().length ?? 0) > 0,
                        }}
                        {...field}
                        value={field?.value}
                        dataCyScope="PatientField"
                    />
                )}
            />
            <Controller
                control={control}
                name="address.postalCode"
                rules={{
                    required: true,
                }}
                render={({ field, fieldState: { error } }) => (
                    <PatientFormField
                        variant="input"
                        label="Code postal"
                        required
                        size="0.33"
                        status={{
                            error,
                            valid: (field.value?.trim().length ?? 0) > 0,
                        }}
                        {...field}
                        value={field?.value}
                        dataCyScope="PatientField"
                    />
                )}
            />
            <Controller
                control={control}
                name="address.city"
                rules={{
                    required: true,
                }}
                render={({ field, fieldState: { error } }) => (
                    <PatientFormField
                        variant="input"
                        label="Ville"
                        required
                        size="0.33"
                        status={{
                            error,
                            valid: (field.value?.trim().length ?? 0) > 0,
                        }}
                        {...field}
                        value={field?.value}
                        dataCyScope="PatientField"
                    />
                )}
            />
        </>
    )
}

export default Address
